// paths

export function imageStoragePath(imageKey) {
  return `images/${imageKey}`;
}

export function thumbnailStoragePath(thumbnailKey) {
  return `thumbnails/${thumbnailKey}`;
}
